module.exports = __webpack_public_path__ + "04baf78bed67b51bfd4043dc16e6bd27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/gaspe/01.jpg
// module id = EZWp
// module chunks = 0